<template>
  <div class="mediaObject"
    :class="themeClass"
  >
    <div class="mediaWrapper">
      <slot name="media"></slot>
    </div>
    <div class="contentWrapper">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mediaObject',
  props: {
    theme: {
      type: String,
      default: 'normal'
    }
  },
  computed: {
    themeClass () {
      return `theme${this.theme}`
    }
  }
}
</script>

<style scoped lang="scss">
.mediaObject {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  border: 1px solid #9b9b9b;
  margin-bottom: 30px;

  @media screen and (max-width: 798px) {
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  &.themenormal {
    background-color: transparent;
  }

  &.themedark {
    background-color: #2e2b40;
  }

  .mediaWrapper,
  .contentWrapper {
    padding: 1em;
    box-sizing: border-box;
    overflow: hidden;
  }

  .mediaWrapper {
    flex-basis: 25%;

    @media screen and (max-width: 798px) {
      width: 50%;
    }
  }

  .contentWrapper {
    flex-basis: 75%;
  }
}
</style>

<style lang="scss">
.mediaObject {
  img {
    max-width: 100%;
  }
}
</style>
